<template>
  <div class="statistics">
    <div>拣货合计：</div>
    <div>
      <span>发货数量：</span>
      <span>{{ sendProductQuantity }}</span>
    </div>
    <div>
      <span>拣货数量：</span>
      <span>{{ pickProductQuantity }}</span>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: true,
  props: ["pickProductQuantity", "sendProductQuantity"],
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.statistics {
  width: 606px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  div {
    font-size: 28px;
    color: rgba(0, 0, 0, 0.6);
    span:nth-child(1) {
      color: rgba(0, 0, 0, 0.6);
    }
    span:nth-child(2) {
      color: rgba(0, 0, 0, 1);
      font-size: 28px;
      font-weight: bold;
    }
  }
}
</style>
